"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useMemo } from "react";
import { useConnectionStatusValue } from "./hooks/useConnectionStatus";
import type { ReactNode } from "react";
import type { ConnectionStatusData } from "./hooks/useConnectionStatus";
const ConnectionStatusContext = createContext<ConnectionStatusData | null>(null);

/**
 * Single subscription for distraction polling and connection-status side effects.
 * Mount once near the app root (e.g. web `QueryProvider`) so multiple UI
 * surfaces can call `useConnectionStatus()` without duplicate fetches.
 */
export function ConnectionStatusProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const value = useConnectionStatusValue();
  const contextValue = value;
  let t1;
  if ($[0] !== children || $[1] !== contextValue) {
    t1 = <ConnectionStatusContext.Provider value={contextValue}>{children}</ConnectionStatusContext.Provider>;
    $[0] = children;
    $[1] = contextValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}

/**
 * Reads connection status from {@link ConnectionStatusProvider}.
 */
export function useConnectionStatus() {
  const ctx = useContext(ConnectionStatusContext);
  if (!ctx) {
    throw new Error("useConnectionStatus must be used within ConnectionStatusProvider");
  }
  return ctx;
}